import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

export const styles = (theme: Theme) => createStyles({
    root: {
    display: 'flex',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
});


class E404 extends React.Component<any, any> {
    public render() {
        const { classes } = this.props;
        const bull = <span className={classes.bullet}>•</span>;
        /* tslint:disable:jsx-no-lambda */
        return (
            <div style={this.props.style}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom={true}>
                            Page Not Found
                        </Typography>
                        <Typography variant="h5" component="h2">
                        pāj {bull} nät {bull} found
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            adjective
                        </Typography>
                        <Typography component="p">
                        in computer network communications, to indicate that the client was able to communicate with a given server, but the server could not find what was requested.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" onClick={() => {
                            window.location.href = 'https://en.wikipedia.org/wiki/HTTP_404';
                        }}>Learn More</Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withStyles(styles)(withRouter(connect(
    mapStateToProps,
)(E404)));



// WEBPACK FOOTER //
// ./src/containers/e-404.tsx